import { render } from "./PieChart2.vue?vue&type=template&id=f36990a4"
import script from "./PieChart2.vue?vue&type=script&lang=js"
export * from "./PieChart2.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__